<template>
<el-container class="app-operate-course-wrap">
  <el-header>  
    <publicBreadCrumb  :breadList="breadList"/>  
    <div class="search-top">
      <div>
        <el-input placeholder="请输入关键字" size="small" v-model="categoryName" clearable style="width:360px" maxlength="10"></el-input>
        <el-button size="small" style="margin-left:20px" @click="handleReset">重置</el-button>
        <el-button type="primary" size="small" @click="getPageCategory">搜索</el-button>
      </div>
      <el-button type="primary" size="small" @click="handleAddAppGuide">新增教程</el-button>
    </div>
  </el-header>
  <el-main>
    <el-container style="height:100%">
      <el-aside style="height:100%;width: 312px;padding:16px 0;">
        <el-scrollbar style="height:calc(100% - 65px);width:100%;">
          <div style="padding:0 12px">
            <draggable v-model="categoryList" filter=".forbid" handle=".move-icon" :move="onMove" chosenClass="chosen" @start="startDrag" @end="endDrag">
              <transition-group>
                <div class="type-row" v-for="(item, index) in categoryList" :class="[selectCategoryRow.id === item.id ?'active-bg':'']" :key="item.id" @click.stop="clickCategory(item)">
                  <span>
                    <img src="@/assets/images/sel-dot-type.png" class="move-icon" style="width:16px;height:16px;"/>
                    <!-- <img src="@/assets/images/no-dot-type.png" style="width:14px;height:14px;vertical-align:text-bottom"/> -->
                    <span class="type-name">{{item.categoryName}}</span>
                  </span>
                  <div class="type-option">
                    <el-button type="text" size="medium" @click.stop="handleEditCategory(item)">编辑</el-button>
                    <el-button type="text" size="medium" style="color:#FB5555" @click.stop="handleDelCategory(item)">删除</el-button>
                  </div>
                </div>
              </transition-group>
            </draggable>
          </div>
        </el-scrollbar>
        <el-button size="small" class="add-item-config" type="primary" @click="handleAddAppCategory"> + 新增教程类目</el-button>
      </el-aside>
      <el-main class="content-form">
         <BaseTable :data="guideTableData" :optimize='true'
              tooltip-effect="dark"
              :column="tableConfig" pagination :auto-scroll="true" :total="total" :page.sync="current"
              :limit.sync="size" @pagination="getPageGuide">
          </BaseTable>
      </el-main>
    </el-container>
  </el-main>
  <AddAppCourseDialog v-if="showAppGuide" :showAppGuide.sync="showAppGuide" :appGuideTitle="appGuideTitle" :selectGuideRow="selectGuideRow"
    @getPageGuide="getPageGuide"></AddAppCourseDialog>
  <AddAppCategoryDialog v-if="showAppCategory" :showAppCategory.sync="showAppCategory" 
    :appCategoryTitle="appCategoryTitle" :selectCategoryRow="selectCategoryRow" @getPageCategory="getPageCategory"></AddAppCategoryDialog>
</el-container>
</template>
<script>
import {pageCategory,categoryDetail,addCategory,updateCategory,delCategory,
  sortCategory,pageGuide,guideDetail,addGuide,updateGuide,delGuide,enabledGuide,disabledGuide} from "@/api/appOperateCourse"
import AddAppCourseDialog from "./component/AddAppCourseDialog.vue";
import AddAppCategoryDialog from "./component/AddAppCategoryDialog.vue";

import draggable from 'vuedraggable'

export default {
  components: {
    AddAppCourseDialog,
    AddAppCategoryDialog,
    draggable
  },
  data() {
    return {
      total: 0,
      selectGuideRow: {},
      selectCategoryRow: {},
      showAppCategory: false,
      appCategoryTitle: '',
      appGuideTitle: '',
      showAppGuide: false,
      size: 10,
      current: 1, 
      tableConfig: [
        {
          label: "教程标题",
          align: "center",
          prop: "guideName", 
          size: "mini"
        },
        {
          label: "教程类目",
          align: "center",
          prop: "categoryName", 
          size: "mini"
        },
        {
          label: "创建时间",
          align: "center",
          prop: "createTime" 
        },
        {
          label: "更新时间",
          align: "center",
          prop: "updateTime" 
        },
        {
          label: "是否启用",
          align: "center",
          render: (h, scope) => {
            if (!scope.row.state) {
              return (
                <span slot="reference" style="display:inline-block;background: #FCB023;height:24px;line-height:24px;width:28px;text-align:center;color:#FFFFFF">
                  否
                </span>
              )
            }
            if (scope.row.state) {
              return (
                <span slot="reference" style="display:inline-block;background: #0CB79F;height:24px;line-height:24px;width:28px;text-align:center;color:#FFFFFF">
                  是
                </span>
              )
            }
          }
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini",
                    disabled: scope.row.state == 1,
                  },
                  on: {
                    click: () => {
                      this.handleEditGuide(scope.row);
                    }
                  }
                },
                "编辑"
              ),
               h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini",
                    disabled: scope.row.state == 1
                  },
                  style: {
                    color: scope.row.state == 1 ? '' : '#FB5555'
                  },
                  on: {
                    click: () => {
                      this.handleDelGuide(scope.row);
                    }
                  }
                }, 
                "删除" 
              ),
               h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.handleChangeState(scope.row);
                    }
                  }
                }, 
                scope.row.state == 0 ? "启用" : '停用'
              )
            ]);
          }
        }
      ],
      total: 0,

      breadList:[{name:'系统设置'},{name:'医生端教程配置'}],

      selectId: '',
      categoryList:[],

      guideTableData: [],
      categoryName: ''
    }
  },
  async created() {
    this.getPageCategory()
  },
  mounted() {},
  methods: {
    onMove() {

    }, 
    startDrag() {

    },
    async endDrag() {
      let res = await sortCategory({
        categoryIds: this.categoryList.map(v => v.id),
        current: 1,
        size: 5000
      })
      if (res.code === 0) {
        
      }
    },
    handleEditGuide(row) {
      this.selectGuideRow = row
      this.showAppGuide = true
      this.appGuideTitle = '编辑教程'
    },
    // 新增教程
    handleAddAppGuide() {
      if (!this.categoryList.length) {
        this.$message.error('请先创建教程类目')
        return
      }
      this.selectGuideRow = {}
      this.showAppGuide = true
      this.appGuideTitle = '新增教程'
    },
    handleAddAppCategory() {
      this.showAppCategory = true
      this.appCategoryTitle = '新增教程类目'
      this.selectCategoryRow = {}
    },
    // 编辑教程
    async handleEditCategory(item) {
      this.showAppCategory = true
      this.appCategoryTitle = '编辑教程类目'
      this.selectCategoryRow = item
    },
    handleReset() {
      this.categoryName = ''
      this.getPageCategory()
    },
    async getPageCategory() {
      let res = await pageCategory({
        categoryName: this.categoryName,
        size: 5000,
        current: 1
      })
      if (res.code === 0) {
        this.categoryList = res.data.records
      }
    },
    
    

    async handleSortCategory() {
      let res = await sortCategory({
        id: row.id
      })
      if (res.code === 0) {
 
      }
    },
    clickCategory(item) {
      this.selectCategoryRow = item
      this.getPageGuide()
    },
    // 获取教程表格数据
    async getPageGuide() {
      if (this.selectCategoryRow.id) {
        let res = await pageGuide({
          categoryId: this.selectCategoryRow.id,
          current: this.current,
          size: this.size
        })
        if (res.code === 0) {
          this.guideTableData = res.data.records
          this.total = res.data.total
        }
      }
    },
    
    // 删除教程
    async handleDelGuide(row) {
      this.$confirm('确定要删除当前教程吗？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        customClass: 'message-del-confirm'
      }).then(async () => {
        let res = await delGuide(row.id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getPageGuide()
        }
      })
    },
    // 启用、停用
    async handleChangeState(row) {
      if (row.state == 1) {
        // 变停用
        let res = await disabledGuide(row.id)
        if (res.code === 0) {
          this.$message.success('成功')
          this.getPageGuide()
        }
      } else {
        // 变启用
        let res = await enabledGuide(row.id)
        if (res.code === 0) {
          this.$message.success('成功')
          this.getPageGuide()
        }
      }
    },

    // 删除类目
    handleDelCategory(item) {
      this.$confirm('确定要删除当前教程标题类目吗？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        customClass: 'message-del-confirm'
      }).then(async () => {
        let res = await delCategory(item.id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getPageCategory()
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
}
.chosen {
  box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
}
.search-top {
  display: flex;
  justify-content: space-between;
}
.app-operate-course-wrap {
  height: 100%;
  width: 100%;
  .active-bg {
    background-color: #ECF4FF; 
  }
  .el-header {
    padding: 0 20px;  
    text-align: left;
    background: #FFFFFF;
    height: auto !important;
    padding-bottom: 20px;
  }
  .menu-name {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 68px;
    text-align: left;
  }
  .tag {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    font-family: PingFangSC-Medium, PingFang SC;
    margin-bottom: 15px;
    display: flex;
    font-weight: 500;
  }
  .tag::before {
    content: '';
    display: block;
    width: 4px;
    height: 15px;
    background: #1A7BFC;
    margin-right: 15px;
    margin-top: 2.5px;
  }
  .el-aside {
    border-radius: 6px;
    background: #FFFFFF;
    height: calc(100% - 68px);
    width:313px;
    margin-right: 16px;
    height: 100%;
    padding: 20px;
    .move-icon {
      cursor: move;
    }
    .type-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // height: 46px;
      padding: 0 5px;
      border-radius: 8px;
      cursor: pointer;
      margin-bottom: 10px;
      height: 40px;
      // width: 288px;
    }
  }
  .content-form {
    background: #FFFFFF;
  }
  // .add-item {
  //   width: 100%;
  //   background-color: #FCFCFC;
  //   border: 1px dashed #D9D9D9;
  //   color: #333333;
  // }
  .add-item-config {
    // // width: 100%;
    // background-color: #FCFCFC;
    // border: 1px dashed #1A7BFC;
    // color: #1A7BFC;
    background-color: #FCFCFC;
    border: 1px dashed #D9D9D9;
    color: #333333;
    margin-top:20px;
    width: calc(100% - 24px);
    height: 35px;
    margin-left: 12px;
  }
  .add-item-config:hover {
    background-color: #FCFCFC;
    border: 1px dashed #1A7BFC;
    color: #1A7BFC;
  }
  .type-name {
    font-size: 12px;
    // font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    // line-height: 46px;
    display: inline-block;
    margin-left: 10px;
    width: 130px;
    overflow: hidden; 
    white-space: nowrap; 
    text-overflow: ellipsis;
  }
  .type-option {
    display: flex;
    align-items: center;
    .el-button {
      font-size: 10px;
      font-weight: 400;
      color: #1A7BFC;
      // line-height: 46px;
    }
  }
  .upload-tips {
    position: absolute;
    bottom: 0;
    left: 140px;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    // line-height: 17px;
  }
  .footer-option {
    text-align:left;
    padding-left:180px;
    .el-button {
      width: 110px;
    }
  }
  /deep/.el-table__header th {
    padding: 0;
    height: 54px;
  }
  .btn-bg {
    background-color: #1A7BFC;
  }
  .el-button--text {
    color: #1A7BFC;
  }
  .line-sepa {
    display: inline-block;
    width: 1px;
    height: 14px;
    background-color: #1A7BFC;
    margin: 0 12px;
  }
  .disable-btn {
    margin-bottom:20px;
    width: 588px;
    margin-left:180px;
    background: #F0F0F0;
    border-radius: 3px;
    border: 1px solid #E9E9E9;
    color: #999999;
    font-size: 12px;
  }
}
</style>
<style lang="less">
.avatar-pic .el-upload {
  border: 1px dashed #d9d9d9;
}
.avatar-uploader .el-upload {
  /* border: 1px dashed #d9d9d9; */
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 130px;
  line-height: 130px;
  text-align: center;
}
.avatar {
  width: 130px;
  height: 130px;
  display: block;
}
.message-del-confirm {
  .el-button--primary {
    background-color: #1A7BFC;
  }
}
</style>
